<template>
  <div class="content">
        <div class="logo">
          <img src='../../public/bannerList/comzen.png' style="height:100%;width:100%;margin-top:10px"/>
        </div>
        <div class="menu">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router @select="handleSelect">
            <el-menu-item index="/">首页</el-menu-item>
            <el-submenu index="2">
              <template slot="title">大数据及效能</template>
              <el-menu-item index="/hadoop/beanstalk" class="titStyle">Beanstalk企业研发管理平台</el-menu-item>
              <el-menu-item index="/hadoop/bigdataPlatform" class="titStyle">大数据测试平台</el-menu-item>
              <el-menu-item index="/hadoop/agileManagement" class="titStyle">敏捷管理咨询</el-menu-item>
              <el-menu-item index="/hadoop/qualityManagement" class="titStyle">质量管理咨询</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">城市大脑</template>
              <el-menu-item index="/cityBrain/socialSolutions" class="titStyle">社会态势解决方案</el-menu-item>
              <el-menu-item index="/cityBrain/importantSolutions" class="titStyle">重点防护解决方案</el-menu-item>
              <el-menu-item index="/cityBrain/warningSolutions" class="titStyle">警情中心解决方案</el-menu-item>
              <el-menu-item index="/cityBrain/manySolutions" class="titStyle">一标N实解决方案</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
              <template slot="title">可视化</template>
              <el-menu-item index="/visual/product" class="titStyle">产品</el-menu-item>
              <el-menu-item index="/visual/developmentPlatform" class="titStyle">开发平台</el-menu-item>
              <el-menu-item index="/visual/apply" class="titStyle">可视化应用</el-menu-item>
              <el-menu-item index="/visual/digitalTwin" class="titStyle">数字孪生应用</el-menu-item>
              <el-menu-item index="/visual/caseIntroduction" class="titStyle">案例介绍</el-menu-item>
            </el-submenu>
            <el-menu-item index="/humanServices">人力服务</el-menu-item>
            <el-menu-item index="/newsCenter">新闻中心</el-menu-item>
            <el-menu-item index="/aboutus">关于我们</el-menu-item>
          </el-menu>
        </div>
  </div>
</template>

<script>
  export default {
    name: 'navmenu',
    data() {
      return{
        activeIndex: '/',
      }
    },
    mounted(){
      this.activeIndex = this.$route.path
      this.menuActive()
    },
    methods: {
      handleSelect(key, keyPath) {
        this.activeIndex = keyPath[1]
      },  
      menuActive(){
        if(this.$route.path == '/newsCenter/activity' || this.$route.path == '/newsCenter/honor'){
          this.activeIndex = '/newsCenter'
        }
      }
    },
  }
</script>

<style lang="scss">
@import '~@/assets/style/elementUi.scss';

.titStyle:hover:hover{
  color: #fff !important;
  opacity: 1 !important;
}

  .content{    
    height: 80px;
    width: 1200px;
    margin: 0 auto;
    .logo{
      width:114px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      // margin-top:20px
    }
    .menu{
      float:right;
      margin-top:-42px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      opacity: 1;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/navmenu.vue